export function convertDamMonitoringValue(value?: string) {
  if (!value) {
    return 'N/A';
  }
  return parseFloat(value.replace(',', '.')).toString();
}
